import React from 'react'
import WebApp from './WebApp'
import MobileApp from './MobileApp'

export default ({ variant }) => {
  return variant === 'web' ? <WebApp /> : <MobileApp />
}
